import React from "react";
import {
  handleChange,
  handleChangeNumeral,
} from "../../../../helpers/handleFormChanges";
import CommonInput from "../../../../components/forms/CommonInput";
import CommonSelect from "../../../../components/forms/CommonSelect";
import { paises } from "../../../../helpers/paisesHelper";
import PropTypes from "prop-types";

function ClienteDadosEx({ valuesHook, sent }) {
  const { values, setValues } = valuesHook;

  return (
    <>
      <div className="row">
        <div className="col-lg-5 mb-3">
          <CommonInput
            label="Nome do cliente"
            id="razao_social"
            value={values.razao_social}
            onChange={(e) => handleChange(e, values, setValues)}
            required
            limit={75}
            sent={sent}
          />
        </div>
        <div className="col-lg-5 mb-3">
          <CommonInput
            label="Logradouro"
            id="logradouro"
            value={values.logradouro}
            onChange={(e) => handleChange(e, values, setValues)}
            required
            limit={40}
            sent={sent}
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInput
            label="N°"
            id="numero"
            value={values.numero}
            onChange={(e) => handleChangeNumeral(e, values, setValues)}
            required
            sent={sent}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-5 mb-3">
          <CommonSelect
            label="País"
            id="cidade"
            value={values.cidade}
            onChange={(e) => {
              const selectedOption = e.target.options[e.target.selectedIndex];

              setValues({
                ...values,
                cidade: e.target.value,
                uf: selectedOption?.dataset?.sigla,
              });
            }}
            data={Object.keys(paises).map((id) => ({
              text: paises[id].nome,
              id: paises[id].nome,
              "data-sigla": paises[id].sigla2,
            }))}
            placeholder="Selecione o país"
            sent={sent}
            required
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInput
            label="Sigla"
            id="uf"
            value={values.uf}
            onChange={(e) => handleChange(e, values, setValues)}
            required
            disabled
            sent={sent}
          />
        </div>
      </div>
    </>
  );
}

ClienteDadosEx.propTypes = {
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  sent: PropTypes.bool.isRequired,
};

export default ClienteDadosEx;
